import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { FiltroAdminDTO } from '../models/filtroAdminDTO';
import { Observable } from 'rxjs';
import {
  RespuestaCrearAdminDTO,
  RespuestaDataUsuarioDTO,
  RespuestaDTO,
  RespuestaEliminarDTO,
} from '../models/respuestaDTO';
import { AdminDTO } from '../models/adminDTO';
import { CrearAdminDTO, ModificarAdminDTO } from '../models/crearAdminDTO';
import { UtilService } from '../../../services/util.service';
import { Constants } from '../../../constants/constants';
import { GenericResponseDto } from '../../../dto/util/generic-response.dto';

@Injectable({
  providedIn: 'root',
})
export class AdministracionUsuariosService {
  private apiUrl = `${environment.apiUrl}/usuario/`;
  constructor(
    private http: HttpClient,
    private utilService: UtilService
  ) {}

  // Lista de administradores líderes
  listarAdminLideres(filtro: FiltroAdminDTO): Observable<RespuestaDTO> {
    return this.http.post<RespuestaDTO>(
      `${this.apiUrl}buscarPerfilUsuario/AdministradoresLideres`,
      filtro
    );
  }

  obtenerUsuariosUltimaSemana(
    filtro: FiltroAdminDTO
  ): Observable<RespuestaDTO> {
    return this.http.post<RespuestaDTO>(
      `${this.apiUrl}buscarPerfilUsuario/administradoresFuncionales/ultimo`,
      filtro
    );
  }
  // Lista de administradores funcionales
  listarAdminFuncionales(filtro: FiltroAdminDTO): Observable<RespuestaDTO> {
    return this.http.post<RespuestaDTO>(
      `${this.apiUrl}buscarPerfilUsuario/AdministradoresFuncionales`,
      filtro
    );
  }
  listarAdminFuncionalesMjd(filtro: FiltroAdminDTO): Observable<RespuestaDTO> {
      return this.http.post<RespuestaDTO>(
        `${this.apiUrl}buscarPerfilUsuario/AdministradoresFuncionalesMjd`,
        filtro
      );
    }

  // Crear usuario
  crearUsuario(datos: CrearAdminDTO): Observable<RespuestaCrearAdminDTO> {
    return this.http.post<RespuestaCrearAdminDTO>(
      `${this.apiUrl}crearAdmin`,
      datos,
      {
        headers: {
          MDJ_TOKEN_AUTH:
            //sessionStorage.getItem(Constants.REFRESH_TOKEN) ?? '',
            this.utilService.getCookie(Constants.MDJ_ACCESS_TOKEN) ?? '',
        },
      }
    );
  }

  // Usuario por ID
  usuarioPorID(id: number): Observable<RespuestaDataUsuarioDTO> {
    return this.http.get<RespuestaDataUsuarioDTO>(
      `${this.apiUrl}informacionPersonal/${id}`
    );
  }

  // Modificar usuario
  modificarUsuario(
    datos: ModificarAdminDTO
  ): Observable<RespuestaCrearAdminDTO> {
    return this.http.post<RespuestaCrearAdminDTO>(
      `${this.apiUrl}modificarAdmin`,
      datos
    );
  }

  // Eliminar usuario
  eliminarUsuario(id: number): Observable<RespuestaEliminarDTO> {
    return this.http.get<RespuestaEliminarDTO>(
      `${this.apiUrl}eliminarUsuario/${id}`
    );
  }

  getPermisoAdmLiderByUsuarioEntidad(
    idUsuario: number,
    idEntidad: number
  ): Observable<GenericResponseDto> {
    return this.http.get<GenericResponseDto>(
      `${this.apiUrl}tiene-permiso-lider/${idUsuario}/${idEntidad}`
    );
  }

  getPermisoAdmFuncionalByUsuarioEntidad(
    idUsuario: number,
    idEntidad: number
  ): Observable<GenericResponseDto> {
    return this.http.get<GenericResponseDto>(
      `${this.apiUrl}tiene-permiso-funcional/${idUsuario}/${idEntidad}`
    );
  }
}
